import { Text } from "@/components/_rebrand/Text";
import cn from "classnames";

const CheckMarkLight = ({ className }: { className: string }) => {
  return <svg className={className} width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5773 0.244078C13.9027 -0.0813593 14.4302 -0.0813591 14.7557 0.244078C15.0811 0.569514 15.0811 1.09703 14.7557 1.42246L5.589 10.5891C5.26356 10.9146 4.73605 10.9146 4.41061 10.5891L0.243945 6.42246L0.186979 6.35899C-0.0799795 6.03168 -0.0611513 5.54917 0.243945 5.24408C0.549042 4.93898 1.03154 4.92015 1.35885 5.18711L1.42233 5.24408L4.9998 8.82155L13.5773 0.244078Z" fill="#001B38" />
  </svg>
}

const CheckMarkDarkViolet = ({ className }: { className: string }) => {
  return <svg className={className} width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5773 0.244078C13.9027 -0.0813593 14.4302 -0.0813591 14.7557 0.244078C15.0811 0.569514 15.0811 1.09703 14.7557 1.42246L5.589 10.5891C5.26356 10.9146 4.73605 10.9146 4.41061 10.5891L0.243945 6.42246L0.186979 6.35899C-0.0799795 6.03168 -0.0611513 5.54917 0.243945 5.24408C0.549042 4.93898 1.03154 4.92015 1.35885 5.18711L1.42233 5.24408L4.9998 8.82155L13.5773 0.244078Z" fill="#E2DCF6" />
  </svg>
}

// Pass an ID from the CMS to avoid generating a unique key. 
export type TextItemWithId = {
  id: string;
  text: string;
  className?: string;
}

export type CheckListProps = {
  items: TextItemWithId[];
  className?: string;
}

const CheckList = ({ items, className }: CheckListProps) => {
  return <div className={cn("space-y-xl", className)}>
    {items.map((item) => (
      <div key={item.id} className="flex items-center gap-s">
        <CheckMarkLight className="hidden visible-light-theme-only" />
        <CheckMarkDarkViolet className="hidden visible-dark-theme-only" />
        <Text type="p2" className="text-primary">{item.text}</Text>
      </div>
    ))}
  </div>
};

export { CheckList };
